import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";

const GenReviewsDiff = () => {

    const { sha, model, prompt } = useParams();

    const [reviewInfo, setReviewInfo] = useState({
        owner: null,
        name: null,
        keywords: [],
        message: null,
        evals: [],
        resolution: null,
    });

    const [diff, setDiff] = useState('');

    function eval_review() {
        let coherent = document.getElementById('Coherent').value;
        let vulnerability = document.getElementById('Vulnerability').value;
        let plausible = document.getElementById('Plausible').value;

        if (coherent === 'Select' || vulnerability === 'Select' || plausible === 'Select') {
            alert('Please fill all fields');
            return;
        }

        fetch(process.env.REACT_APP_BACKEND_URL + 'eval_genReviewDiscrepancy', {
            method: "POST",
            headers: {
                "Content-Type": "text/plain",
            },
            body: JSON.stringify({
                token: localStorage.getItem("token"),
                username: localStorage.getItem("user"),
                sha: sha,
                model: model,
                prompt: prompt,
                coherent: coherent === 'true',
                vulnerability: vulnerability === 'true',
                plausible: plausible === 'true',
            }),
        })
            .then(response => response.json())
            .then(data => {
                if (data.res === 'ok') {
                    alert('Discrepancy evaluated');
                } else {
                    alert('Error evaluating Discrepancy');
                }
            })
            .catch(error => {
                console.error("Error:", error);
                alert('Error evaluating Discrepancy');
            });

    }

    useEffect(() => {
        fetch(process.env.REACT_APP_BACKEND_URL + 'get_generatedReviewDiscrepancy/' + sha + '/' + model + '/' + prompt, {
            method: "POST",
            headers: {
                "Content-Type": "text/plain",
            },
            body: JSON.stringify({ token: localStorage.getItem("token"), username: localStorage.getItem("user") }),
        })
            .then(response => response.json())
            .then(data => {
                setReviewInfo(data);
                if (data.resolution.vulnerability != null) {
                    document.getElementById('Coherent').value = data.resolution.coherent ? 'true' : 'false';
                    document.getElementById('Vulnerability').value = data.resolution.vulnerability ? 'true' : 'false';
                    document.getElementById('Plausible').value = data.resolution.plausible ? 'true' : 'false';
                }
            })
            .catch(error => {
                console.error("Error:", error);
            });
    }, [sha, model, prompt]);

    useEffect(() => {
            fetch(process.env.REACT_APP_BACKEND_URL + 'get_commit_diff/' + sha, {
                method: "POST",
                headers: {
                    "Content-Type": "text/plain",
                },
                body: JSON.stringify({ token: localStorage.getItem("token"), username: localStorage.getItem("user") }),
            })
                .then(response => response.json())
                .then(data => {
                    setDiff(data.diff); 
                })
                .catch(error => {
                    console.error("Error fetching diff:", error);
                });
        }, [sha]);


    return (
        <>
            <div className="m-10">
                <div className="border-b border-gray-900/10 pb-12 justify-center">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Review</h1>
                </div>
            </div>

            <div className="m-5 border-b border-gray-900/10 pb-12 grid md:grid-cols-3 gap-4 sm:grid-cols-1">
                <div className="col-span-1 break-words">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Repository:</h1>
                    <p>{reviewInfo.owner}/{reviewInfo.name}</p>
                </div>
                <div className="col-span-1 break-words">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">URL:</h1>
                    <Link target="_blank" to={'https://github.com/' + reviewInfo.owner + '/' + reviewInfo.name + '/commit/' + sha}>
                        <p className="text-blue-500 hover:underline">
                            https://github.com/{reviewInfo.owner}/{reviewInfo.name}/commit/{sha}
                        </p>
                    </Link>
                    <h1 className="text-base font-semibold leading-7 text-gray-900">URL eval:</h1>
                    <a
                    href={window.location.origin + '/genReview/' + sha}
                    target="_blank"
                    rel="noopener noreferrer"
                    >
                    <p className="text-blue-500 hover:underline">
                        {window.location.origin}/genReview/{sha}
                    </p>
                    </a>

                </div>
                <div className="col-span-1 break-words">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Keywords:</h1>
                    <p>{reviewInfo.keywords.join(', ')}</p>
                </div>
                <div className="col-span-1 break-words">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Message:</h1>
                    <p>{reviewInfo.message}</p>
                </div>
                <div className="col-span-1 break-words">
                    <div className="col-span-1 shadow-md p-3 overflow-y-auto h-96 bg-gray-50 relative">
                        {/* Copy Button */}
                        <button
                            onClick={() => {
                                const textToCopy = `Message:\n${reviewInfo.message}\n\nFile Diff:\n${diff}`;
                                navigator.clipboard.writeText(textToCopy)
                                    .catch(err => console.error('Failed to copy: ', err));
                            }}
                            className="absolute top-2 right-2 rounded-md bg-gray-800 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-800"
                        >
                            Copy
                        </button>

                        {/* Message and Diff */}
                        <h1 className="text-base font-semibold leading-7 text-gray-900">File Diff:</h1>
                        <pre className="text-sm whitespace-pre-wrap text-left">{diff}</pre>
                    </div>
                </div>
                <div className="col-span-1 break-words">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Generated Review:</h1>
                    <p>{reviewInfo.review}</p>
                </div>

            </div>

            <div className="m-5 border-b border-gray-900/10 pb-12">
                <div className="">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Resolution:</h1>
                </div>
                <div className="grid md:grid-cols-3 gap-4 sm:grid-cols-1">
                    <div className="col-span-1 break-words">
                        <label className="text-base font-semibold leading-7 text-gray-900">Coherent:</label>
                        <select id="Coherent" className="w-full">
                            <option value="Select">Select</option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </div>
                    <div className="col-span-1 break-words">
                        <label className="text-base font-semibold leading-7 text-gray-900">Vulnerability:</label>
                        <select className="w-full" id="Vulnerability">
                            <option value="Select">Select</option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </div>
                    <div className="col-span-1 break-words">
                        <label className="text-base font-semibold leading-7 text-gray-900">Plausible:</label>
                        <select className="w-full" id="Plausible">
                            <option value="Select">Select</option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </div>
                </div>
                
                {/* Conditional Button to evaluate the review */}
                {localStorage.getItem("user") === 'lcentellas' ? 
                <div className="mt-4 flex grid justify-items-end gap">
                <button onClick={eval_review}
                    className="rounded-md bg-gray-800 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grey-800"
                >
                    Evaluate
                </button>
                </div>
                :
                null}
                
            </div>

            <div className="m-5 border-b border-gray-900/10 pb-12">
                <div className="">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Evaluations:</h1>
                </div>
                <div className="grid md:grid-cols-2 gap-2 sm:grid-cols-1">
                {reviewInfo.evals.map((element, index) => (
                    <div key={index} className="col-span-1 shadow-md p-3 overflow-y-auto h-96">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Eval {element.reviewer}</h1>
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Coherent:</h1>
                    <p>{element.coherent ? 'True' : 'False'}</p>
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Vulnerability:</h1>
                    <p>{element.vulnerability ? 'True' : 'False'}</p>
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Plausible:</h1>
                    <p>{element.plausible ? 'True' : 'False'}</p>
                    </div>
                ))}
                </div>

            </div>
        </>
    );
}

export default GenReviewsDiff;